module.exports = __webpack_public_path__ + "Flag-446.5fe72ba20815e63a6fcc3396c8d8a828.svg";